import axios from "axios";
import { ErrorMessage, Field, FieldArray, Formik, FormikConsumer, FormikProps, useFormik } from "formik";
import React, { Component, useEffect, useState } from 'react';
import internal from "stream";
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import { API_URL_LARAVEL } from "../config/config";
import InputField from "./shared-component/Input/InputField";

type DomandaFields = {
    nome: string,
    cognome: string,
    comunedomanda: number,
    cf: string,
    sesso: string,
    nascita: string,
    nazionenascita: string,
    comunenascita: string,
    provincianascita: string,
    cittadinanza: string,
    indirizzoresidenza: string,
    civicoresidenza: string,
    email: string,
    confermaemail: string,
    cellulare: string,
    iban: string,
    indirizzodomicilio: string,
    telefono: string,
    figli: [],
    valoreisee: number,


    dichiara01: boolean,
    dichiara02: boolean,

    dichiara1: boolean,
    dichiara2: boolean,
    dichiara00: boolean,
    dichiara4: boolean,
    dichiara5: boolean,

    allegati: []


}

const MAX_FILE_SIZE = 2000400; //100KB

const validFileExtensions = { image: ['jpg', 'pdf', 'tif', 'png', 'jpeg'] };

const yupSchema = Yup.object().shape({
    nome: Yup.string().required('Nome è richiesto').min(2, "inserire almeno 2 caratteri"),
    cognome: Yup.string().required('Obbligatorio').min(2, "inserire almeno 2 caratteri"),
    comunedomanda: Yup.string().required('Obbligatorio'),
    cf: Yup.string().required('Obbligatorio').matches(
        /^[A-Za-z]{6}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{3}[A-Za-z]{1}$/,
        "Codice fiscale non conforme"
    ),
    sesso: Yup.string().required('Obbligatorio'),
    nascita: Yup.string().required('Obbligatorio'),
    nazionenascita: Yup.string().required('Obbligatorio'),
    comunenascita: Yup.string().required('Obbligatorio'),
    provincianascita: Yup.string().required('Obbligatorio'),
    cittadinanza: Yup.string().required('Obbligatorio'),
    /*  iban: Yup.string().required('Obbligatorio').matches(
          /^(it|IT)[0-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$/,
          "Iban non conforme"
      ), */
    indirizzoresidenza: Yup.string().required('Obbligatorio'),
    civicoresidenza: Yup.string().required('Obbligatorio'),
    email: Yup.string().email().matches(/^(?!.*@[^,]*,)/).required('Obbligatorio'),
    confermaemail: Yup.string().email().matches(/^(?!.*@[^,]*,)/).required('Obbligatorio').oneOf([Yup.ref('email'), null], "Email diversa!"),
    cellulare: Yup.string().required('Obbligatorio'),
    telefono: Yup.string(),
    indirizzodomicilio: Yup.string(),
    // telefono: Yup.string().required('Obbligatorio'),
    valoreisee: Yup.number().required('Obbligatorio'),
    dichiara01: Yup.boolean().isTrue(),
    dichiara02: Yup.boolean().isTrue(),
    dichiara00: Yup.boolean().isTrue(),

    dichiara1: Yup.boolean().isTrue(),
    dichiara2: Yup.boolean().isTrue(),
    dichiara3: Yup.boolean().isTrue(),
    dichiara4: Yup.boolean().isTrue(),
    dichiara5: Yup.boolean().isTrue(),

    allegati: Yup.array().of(

        Yup.object().shape({
            fileisee: Yup
                .mixed()
                .required("Required")
                .test("is-valid-size", "Dimensione Massima 2M",
                    value => value && value.size <= MAX_FILE_SIZE)
            ,
            dichiarazionenucleo: Yup
                .mixed()
                .required("Required")
                .test("is-valid-size", "Dimensione Massima 2M",
                    value => value && value.size <= MAX_FILE_SIZE)
            ,
            minoridisabili: Yup
                .mixed().test("is-valid-size", "Dimensione Massima 2M",

                    (value) => {
                        if (!value) return true

                        return value && value.size <= MAX_FILE_SIZE
                    })

            ,
            documento: Yup
                .mixed()
                .required("Required")
                .test("is-valid-size", "Dimensione Massima 2M",
                    value => value && value.size <= MAX_FILE_SIZE)
            ,
            altro: Yup
                .mixed().test("is-valid-size", "Dimensione Massima 2M",

                    (value) => {
                        if (!value) return true

                        return value && value.size <= MAX_FILE_SIZE
                    })

            ,

            sostitutiva: Yup
                .mixed()
                .required("Required")
                .test("is-valid-size", "Dimensione Massima 2M",
                    value => value && value.size <= MAX_FILE_SIZE)
        })
    ),



    figli: Yup.array().of(
        Yup.object().shape({
            nome: Yup.string().required("Nome richiesto"),
            cognome: Yup.string().required("Cognome richiesto"),
            natoa: Yup.string().required('Obbligatorio'),
            natoil: Yup.string().required('Obbligatorio'),
            centri: Yup.array().of(
                Yup.object().shape({
                    centro: Yup.string().required('Obbligatorio'),
                    frequenzada: Yup.string().required('Obbligatorio'),
                    frequenzaa: Yup.string().required('Obbligatorio'),
        
                })
            ).min(1, 'Aggiungere almeno un Centro per ogni minore inserito')
        })
    ).min(1, 'Aggiungere almeno un minore')
})

const valoriIniziali: DomandaFields = {
    /*
    nome: "aaaa",
    cognome: "aaaaa",
    comunedomanda: 0,
    cf: "aaaa",
    sesso: "a",
    nascita: "2021-02-02",
    nazionenascita: "aaa",
    comunenascita: "aaa",
    provincianascita: "aa",
    cittadinanza: "a",
   
    indirizzoresidenza: "aa",
    civicoresidenza: "aaa",

    email: "aaaaa",
    confermaemail: "aaaaa",
    cellulare: "aaaa",
    telefono: "erewr",
    indirizzodomicilio:"erwrwer",
    figli:[],

    dichiara1:false,
    dichiara2:false,
    dichiara3:false,
    dichiara4:false,
    dichiara5:false,
    dichiara6:false,
    dichiara7:false,
    dichiara8:false,

//*/
    valoreisee: 0,
    nome: "",
    cognome: "",
    comunedomanda: 0,
    cf: "",
    sesso: "",
    nascita: "",
    nazionenascita: "",
    comunenascita: "",
    provincianascita: "",
    cittadinanza: "",
    indirizzoresidenza: "",
    civicoresidenza: "",
    iban: "",
    email: "",
    confermaemail: "",
    cellulare: "",
    telefono: "",
    indirizzodomicilio: "",
    figli: [],
    dichiara01: false,
    dichiara02: false,
    dichiara00: false,
    dichiara1: false,
    dichiara2: false,

    dichiara4: false,
    dichiara5: false,

    allegati: []
    //*/
}
const Toast = Swal.mixin({
    position: 'top-end',
    timer: 2000,
    showConfirmButton: false,
    toast: true,
})


const Domanda = () => {


    const [visual, setsetvisual] = useState(false)
    const [update, setupdate] = useState(false);
    const stampa_id = (id: any) => {
        var nw = window.open();
        var html = document.body.innerHTML + '<style> .body{ width: 200px} </style>'

        nw.document.write(document.body.innerHTML);
        //   nw.print();
        //   nw.close();
    }


    const aggiungicentro = (e: any, formik: any) => {

     //   console.log('figli', formik.values.figli[e]);
        formik.values.figli[e].centri.push({
            centro: '',
            frequenzada: '',
            frequenzaa: ''
        }
        );

      //  console.log('figli', formik.values.figli[e]);

        setupdate(!update);
    }


    const aggiungiFigli = (e: any, formik: any) => {
        //   console.log('figli', formik.values.figli);

        formik.values.figli = [];

        for (let i = 0; i < e; i++) {

            formik.values.figli.push({
                nome: '',
                cognome: '',
                natoa: '',
                natoil: '',
                centri: []
            }
            );

        }
        //   console.log('figli', e, formik.values.figli);

        setsetvisual(true);

        setupdate(!update);

        if (!visual) {
            formik.values.allegati.push({
                documento: null,
                fileisee: null,
                dichiarazionenucleo: null,
                minoridisabili: null,
                sostitutiva: null,
                altro: null
            }
            );
        }

    }


    return (
        <>
            <Formik initialValues={valoriIniziali}
                validationSchema={yupSchema}
                validateOnBlur={false}
                validateOnChange={false}

                onSubmit={(values) => {

                    const fileInput = document.querySelectorAll('input[type="file"]');

                  //  console.log(fileInput);
                    const data = JSON.stringify({ ...values })
                    const fd = new FormData();
                    // append directly as part of the postData in plain text
                    fd.append('istanzajson', data);
                    fd.append('identificativo', "1009124");
                    fd.append('nome', "Domanda attività estive 23");

                    fileInput.forEach((docItem) => {
                        fd.append(docItem.id, (document.getElementById(docItem.id) as HTMLInputElement).files[0]);
                    });


                    axios.post(API_URL_LARAVEL + '/istanza', fd, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                    ).then((response) => {

                       // console.log(response);

                        if (response.data.success) {
                            Toast.fire({
                                title: response.data.text,
                                icon: 'success'
                            });

                            window.location.href = "/esito?id=" + response.data.result;


                        }
                    }).catch((err) => {
                        console.log(err);

                        alert('Errore imprevisto. Provare a rinominare i file allegati senza utilizzare caratteri speciali');

                        document.getElementById('spinner').style.display = 'none';
                        document.getElementById('_conferma').style.display = 'inline';

                    });

                    //    alert(JSON.stringify(values));
                }}>
                {(formik: FormikProps<any>) => (
                    <div className="form">
                        <div className="form-group">
                            <div className="col-sm-5 col-sm-offset-1" >
                                <table>
                                    <tbody><tr>
                                        <td>
                                            <ol className="breadcrumb" style={{ backgroundColor: 'white' }}>

                                                <li className="active">
                                                    DOMANDA PER LA RICHIESTA DI CONTRIBUTO ECONOMICO PER LA
                                                    FREQUENZA PER MINORI PRESSO CENTRI ESTIVI, SERVIZI SOCIO-EDUCATIVI TERRITORIALI
                                                    E  CENTRI CON FUNZIONE EDUCATIVA E RICREATIVA – ANNUALITÀ 2024.
                                                </li>
                                            </ol>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                        </div>



                        {<div id="div_domanda">
                            <br />
                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Dati Anagrafici </div></div>
                            <div className="row">
                                <div className="col-sm">
                                    <Field component={InputField} id='nome' label='Nome' />
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='cognome' label='Cognome' />
                                </div>
                                <div className="col-sm">
                                    <div className="form-group">
                                        <label htmlFor='cf'>Codice Fiscale</label>
                                        <input type="text" className="form-control" name='cf' id='cf' onChange={event => formik.setFieldValue('cf', event.target.value)} />
                                        <small className="error">  <ErrorMessage name='cf' /> </small>

                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm">
                                    <div className="form-group">
                                        <div className="select-wrapper">
                                            <label htmlFor="sesso">Sesso</label>
                                            <select id="sesso" onChange={event => formik.setFieldValue('sesso', event.target.value)}>
                                                <option selected value="">Scegli un'opzione</option>
                                                <option value="M">M</option>
                                                <option value="F">F</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div className="form-group">
                                        <label className="active" htmlFor="nascita">Data di nascita (gg/mm/aaaa)</label>
                                        <input type="date" id="nascita" name="nascita" onChange={evt => {
                                            formik.setFieldValue('nascita', evt.target.value)
                                        }} />
                                        <ErrorMessage name={`nascita`} />

                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div className="select-wrapper">
                                        <label htmlFor="nazionenascita">Nazione di nascita</label>
                                        <select id="nazionenascita" onChange={event => formik.setFieldValue('nazionenascita', event.target.value)} >
                                            <option selected value="">Scegli un'opzione</option>
                                            <option value={122}>ITALIA</option><option value={1}>AFGHANISTAN</option><option value={2}>ALBANIA</option><option value={3}>ALGERIA</option><option value={4}>ANDORRA</option><option value={5}>ANGOLA</option><option value={6}>ANGUILLA</option><option value={7}>ANTIGUA E BARBUDA</option><option value={8}>ANTILLE BRITANNICHE</option><option value={9}>ANTILLE OLANDESI</option><option value={10}>ARABIA SAUDITA</option><option value={11}>ARGENTINA</option><option value={12}>ARMENIA</option><option value={13}>AUSTRALIA</option><option value={14}>AUSTRIA</option><option value={15}>AZERBAIGIAN</option><option value={16}>BAHAMA</option><option value={17}>BAHREIN</option>
                                            <option value={18}>BANGLADESH</option><option value={19}>BARBADOS</option><option value={20}>BELGIO</option><option value={21}>BELIZE</option><option value={22}>BENIN</option><option value={23}>BERMUDA (ISOLE)</option><option value={24}>BHUTAN</option><option value={25}>BIELORUSSIA</option><option value={26}>BIRMANIA</option><option value={27}>BOLIVIA</option><option value={28}>BOSNIA ED ERZEGOVINA</option><option value={29}>BOTSWANA</option><option value={30}>BRASILE</option><option value={31}>BRUNEI</option><option value={32}>BULGARIA</option><option value={33}>BURKINA FASO</option><option value={34}>BURUNDI</option><option value={35}>CAMBOGIA</option><option value={36}>CAMERUN</option><option value={37}>CANADA</option><option value={38}>CAPO VERDE</option><option value={39}>CAYMAN (ISOLE)</option><option value={40}>CECOSLOVACCHIA</option><option value={41}>CENTRAFRICANA REPUBBLICA</option><option value={42}>CHRISTMAS (ISOLA)</option><option value={43}>CIAD</option><option value={44}>CILE</option><option value={45}>CINA (REPUBBLICA POPOLARE)</option><option value={46}>CIPRO</option><option value={47}>CITTA' DEL VATICANO</option><option value={48}>ISOLE COCOS (KEELING)</option><option value={49}>COLOMBIA</option><option value={50}>COMORE</option>
                                            <option value={51}>CONGO REBUBBLICA DEMOCRATICA (ZAIRE)</option><option value={52}>CONGO REPUBBLICA POPOLARE</option><option value={53}>COOK</option><option value={54}>COREA DEL NORD, REPUBBLICA DEMOCRATICA</option><option value={55}>COREA DEL SUD, REPUBBLICA DI COREA</option><option value={56}>COSTA D'AVORIO</option><option value={57}>COSTA RICA</option><option value={58}>CROAZIA</option><option value={59}>CUBA</option><option value={60}>DANIMARCA</option><option value={61}>DIPENDENZE AUSTRALIANE</option><option value={62}>DIPENDENZE BRITANNICHE</option><option value={63}>DIPENDENZE CANADESI</option><option value={64}>DIPENDENZE FRANCESI</option><option value={65}>DIPENDENZE NEOZELANDESI</option><option value={66}>DIPENDENZE NORVEGESI ANTARTICHE</option><option value={67}>DIPENDENZE NORVEGESI ARTICHE</option><option value={68}>DIPENDENZE RUSSE</option><option value={69}>DIPENDENZE STATUNITENSI</option><option value={70}>DIPENDENZE SUDAFRICANE</option><option value={71}>DOMINICA</option><option value={72}>ECUADOR</option><option value={73}>EGITTO</option><option value={74}>EL SALVADOR</option><option value={75}>EMIRATI ARABI UNITI</option><option value={76}>ERITREA</option><option value={77}>ESTONIA</option><option value={78}>ETIOPIA</option><option value={79}>FAER OER (Isole)</option><option value={80}>FIGI O VITI</option><option value={81}>FILIPPINE</option><option value={82}>FINLANDIA</option><option value={83}>FRANCIA</option><option value={84}>GABON</option><option value={85}>GAMBIA</option><option value={86}>TERRITORI PALESTINESI (GAZA)</option><option value={87}>GEORGIA</option><option value={88}>GERMANIA</option><option value={89}>GERMANIA REPUBBLICA DEMOCRATICA</option><option value={90}>GERMANIA REPUBBLICA FEDERALE</option><option value={91}>GHANA</option><option value={92}>GIAMAICA</option>
                                            <option value={93}>GIAPPONE</option><option value={94}>GIBILTERRA</option><option value={95}>GIBUTI</option><option value={96}>GIORDANIA</option><option value={97}>GRAN BRETAGNA E IRLANDA DEL NORD</option><option value={98}>GRECIA</option><option value={99}>GRENADA</option><option value={100}>GROENLANDIA</option><option value={101}>GUADALUPA</option><option value={102}>GUAM (ISOLA)</option><option value={103}>GUATEMALA</option><option value={104}>GUIANA FRANCESE</option><option value={105}>GUINEA</option><option value={106}>GUINEA BISSAU</option><option value={107}>GUINEA EQUATORIALE</option><option value={108}>GUYANA</option><option value={109}>HAITI</option><option value={110}>HONDURAS</option><option value={111}>HONG KONG</option><option value={112}>INDIA</option><option value={113}>INDONESIA</option><option value={114}>IRAN</option><option value={115}>IRAQ</option><option value={116}>IRIAN OCCIDENTALE</option><option value={117}>IRLANDA (Eire)</option><option value={118}>ISLANDA</option>
                                            <option value={119}>ISOLE CILENE (PASQUA E SALA Y GOMEZ)</option><option value={120}>ISOLE VERGINI BRITANNICHE</option><option value={121}>ISRAELE</option><option value={123}>JUGOSLAVIA</option><option value={124}>KAZAKISTAN</option><option value={125}>KENYA</option><option value={126}>KIRGHIZISTAN</option><option value={127}>KIRIBATI</option><option value={128}>KUWAIT</option><option value={129}>LA REUNION (ISOLA)</option><option value={130}>LAOS</option><option value={131}>LESOTHO</option><option value={132}>LETTONIA</option><option value={133}>LIBANO</option><option value={134}>LIBERIA</option><option value={135}>LIBIA</option><option value={136}>LIECHTENSTEIN</option><option value={137}>LITUANIA</option><option value={138}>LUSSEMBURGO</option><option value={139}>MACAO</option><option value={140}>MACEDONIA</option><option value={141}>MACQUARIE (ISOLE)</option><option value={142}>MADAGASCAR</option><option value={143}>MALAWI</option>
                                            <option value={144}>MALAYSIA</option><option value={145}>MALDIVE</option><option value={146}>MALI</option><option value={147}>MALTA</option><option value={148}>MALVINE O FALKLAND (ISOLE)</option><option value={149}>MAN (ISOLA)</option><option value={150}>MARIANNE (ISOLE)</option><option value={151}>MAROCCO</option><option value={152}>MARSHALL</option><option value={153}>MARTINICA</option><option value={154}>MAURITANIA</option><option value={155}>MAURIZIO</option><option value={156}>MAYOTTE (ISOLA)</option><option value={157}>MESSICO</option><option value={158}>MICRONESIA STATI FEDERATI</option><option value={159}>MIDWAY</option><option value={160}>MOLDAVIA</option><option value={161}>MONACO</option><option value={162}>MONGOLIA</option><option value={163}>MONTSERRAT</option><option value={164}>MOZAMBICO</option><option value={165}>NAMIBIA</option><option value={166}>NAURU</option><option value={167}>NEPAL</option><option value={168}>NICARAGUA</option><option value={169}>NIGER</option><option value={170}>NIGERIA</option><option value={171}>NIUE O SAVAGE (ISOLE)</option><option value={172}>NORFOLK (ISOLE DEL MAR DEI CORALLI)</option><option value={173}>NORMANNE (ISOLE)</option><option value={174}>NORVEGIA</option><option value={175}>NUOVA CALEDONIA (ISOLE E DIPENDENZE)</option><option value={176}>NUOVA ZELANDA</option><option value={177}>OMAN</option><option value={178}>PAESI BASSI (OLANDA)</option>
                                            <option value={179}>PAKISTAN</option><option value={180}>PALAU</option><option value={181}>PANAMA</option><option value={182}>PANAMA ZONA DEL CANALE</option><option value={183}>PAPUA NUOVA GUINEA</option><option value={184}>PARAGUAY</option><option value={185}>PERU'</option><option value={186}>PITCAIRN (E DIPENDENZE)</option><option value={187}>POLINESIA FRANCESE (ISOLE)</option><option value={188}>POLONIA</option><option value={189}>PORTOGALLO</option><option value={190}>PUERTO RICO</option><option value={191}>QATAR</option><option value={192}>REPUBBLICA CECA</option><option value={193}>REPUBBLICA DELLA GUAYANA</option><option value={194}>REPUBBLICA DOMINICANA</option><option value={195}>ROMANIA</option><option value={196}>RUANDA</option><option value={197}>RUSSIA (FEDERAZIONE RUSSA)</option><option value={198}>SAINT KITTS E NEVIS</option><option value={199}>SANTA LUCIA</option><option value={200}>SAINT PIERRE ET MIQUELON</option><option value={201}>SAINT VINCENT E GRENADINE</option><option value={202}>SALOMONE</option><option value={203}>SAMOA</option><option value={204}>SAMOA AMERICANE (ISOLE)</option><option value={205}>SAN MARINO</option><option value={206}>SANT'ELENA (ISOLA)</option><option value={207}>SAO TOME' E PRINCIPE</option><option value={208}>SEICELLE</option><option value={209}>SENEGAL</option><option value={210}>SIERRA LEONE</option><option value={211}>SINGAPORE</option><option value={212}>SIRIA</option><option value={213}>SLOVACCHIA (REPUBBLICA)</option><option value={214}>SLOVENIA</option><option value={215}>SOMALIA</option><option value={216}>SPAGNA</option><option value={217}>SRI LANKA</option><option value={218}>STATI UNITI D'AMERICA</option><option value={219}>STRANIERO</option><option value={220}>SUDAFRICANA REBUBBLICA</option><option value={221}>SUDAN</option><option value={222}>SURINAME</option><option value={223}>SVEZIA</option><option value={224}>SVIZZERA</option><option value={225}>SWAZILAND</option><option value={226}>TAGIKISTAN</option><option value={227}>TAIWAN (FORMOSA)</option><option value={228}>TANZANIA</option><option value={229}>THAILANDIA</option><option value={230}>TIMOR (ISOLA)</option><option value={231}>TOGO</option><option value={232}>TOKELAU (ISOLE DELL'UNIONE)</option><option value={233}>TONGA (ISOLE DEGLI AMICI)</option><option value={234}>TRINIDAD E TOBAGO</option>
                                            <option value={235}>TUNISIA</option><option value={236}>TURCHIA</option><option value={237}>TURKEMENISTAN</option><option value={238}>TURKS E CAICOS (ISOLE)</option><option value={239}>TUVALU</option><option value={240}>UCRAINA</option><option value={241}>UGANDA</option><option value={242}>UNGHERIA</option><option value={243}>URUGUAY</option><option value={244}>UZBEKISTAN</option><option value={245}>VANUATU</option><option value={246}>VENEZUELA</option>
                                            <option value={247}>ISOLE VERGINI AMERICANE</option><option value={248}>VIETNAM</option><option value={249}>VOLTA (ALTOVOLTA)</option><option value={250}>WALLIS E FUTUNA (ISOLE)</option><option value={251}>YEMEN</option><option value={252}>ZAMBIA</option><option value={253}>ZIMBABWE</option><option value={254}>Kosovo</option><option value={255}>SERBIA E MONTENEGRO</option><option value={256}>URSS - Unione Repubbliche Socialiste Sovietiche</option><option value={257}>SIERRA LEONE</option><option value={258}>APOLIDE</option><option value={259}>MONTENEGRO</option><option value={260}>TOGO</option><option value={261}>TERRITORI PALESTINESI</option><option value={263}>SERBIA</option>
                                        </select>
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-sm">
                                    <Field component={InputField} id='comunenascita' label='Comune di nascita' />
                                </div>
                                <div className="col-sm">

                                    <Field component={InputField} id='provincianascita' label='provincia di nascita' />

                                </div>
                                <div className="col-sm">
                                    <div className="select-wrapper">
                                        <label htmlFor="cittadinanza">Cittadinanza</label>
                                        <select id="cittadinanza" onChange={event => formik.setFieldValue('cittadinanza', event.target.value)} >
                                            <option selected value="">Scegli un'opzione</option>
                                            <option value={122}>ITALIANA</option><option value={1}>AFGHANA</option><option value={2}>ALBANESE</option><option value={3}>ALGERINA</option><option value={4}>ANDORREGNA</option><option value={5}>ANGOLESE</option><option value={6}>INGLESE (ANGUILLA)</option><option value={7}>ANTIGUA E BARBUDA</option><option value={8}>ANTILLE BRITANNICHE</option><option value={9}>ANTILLESE</option><option value={10}>ARABA (ARABIA SAUDITA)</option><option value={11}>ARGENTINA</option><option value={12}>ARMENA</option><option value={13}>AUSTRALIANA</option><option value={14}>AUSTRIACA</option><option value={15}>AZBECA</option><option value={16}>BAHAMA</option><option value={17}>BAHREIN</option><option value={18}>BANGLADESE</option><option value={19}>BARBADOS</option><option value={20}>BELGA</option><option value={21}>BELIZE</option><option value={22}>BENINESE</option><option value={23}>BERMUDA (ISOLE)</option><option value={24}>BHUTAN</option><option value={25}>BIELORUSSA</option><option value={26}>BIRMANA</option><option value={27}>BOLIVIANA</option><option value={28}>BOSNIACA</option><option value={29}>BOTSWANA</option><option value={30}>BRASILIANA</option><option value={31}>BRUNEI</option><option value={32}>BULGARA</option><option value={33}>BURKINABE</option><option value={34}>BURUNDESE</option><option value={35}>CAMBOGIANA</option><option value={36}>CAMERUNENSE</option><option value={37}>CANADESE</option><option value={38}>CAPOVERDIANA</option><option value={39}>INGLESE (ISOLE CAYMAN)</option><option value={40}>CECOSLOVACCA</option><option value={41}>CENTRAFRICANA REPUBBLICA</option><option value={42}>AUSTRALIANA (ISOLA CHRISTMAS)</option><option value={43}>CHADIANA</option><option value={44}>CILENA</option><option value={45}>CINESE (REPUBBLICA POPOLARE CINESE)</option><option value={46}>CIPRIOTA</option><option value={47}>VATICANA</option><option value={48}>ISOLE COCOS (KEELING)</option><option value={49}>COLOMBIANA</option><option value={50}>COMORE</option>
                                            <option value={51}>ZAIRESE</option><option value={52}>CONGOLESE</option><option value={53}>COOK</option><option value={54}>COREANA (COREA DEL NORD)</option><option value={55}>COREANA (COREA DEL SUD)</option><option value={56}>IVORIANA</option><option value={57}>COSTA RICA</option><option value={58}>CROATA</option><option value={59}>CUBANA</option><option value={60}>DANESE</option><option value={61}>AUSTRALIANA (DIPENDENZE AUSTRALIANE)</option><option value={62}>INGLESE (DIPENDENZE BRITANNICHE)</option><option value={63}>CANADESE (DIPENDENZE CANADESI)</option><option value={64}>FRANCESE (DIPENDENZE FRANCESI)</option><option value={65}>NEOZELANDESE (DIPENDENZE NEOZELANDESI)</option><option value={66}>NORVEGESE (DIPENDENZE NORVEGESI ANTARTICHE)</option><option value={67}>NORVEGESE (DIPENDENZE NORVEGESI ARTICHE)</option><option value={68}>RUSSA (DIPENDENZE RUSSE)</option><option value={69}>AMERICANA (DIPENDENZE STATUNITENSI)</option><option value={70}>SUDAFRICANA (DIPENDENZE SUDAFRICANE)</option><option value={71}>DOMINICA</option><option value={72}>ECUADOREGNA</option><option value={73}>EGIZIANA</option><option value={74}>SALVADOREGNA</option><option value={75}>ARABA (EMIRATI ARABI UNITI)</option><option value={76}>ERITREA</option><option value={77}>ESTONE</option><option value={78}>ETIOPE</option><option value={79}>FAER OER (Isole)</option><option value={80}>FIGI O VITI</option><option value={81}>FILIPPINA</option><option value={82}>FINLANDESE</option><option value={83}>FRANCESE (FRANCIA)</option><option value={84}>GABONENSE</option><option value={85}>GAMBIANA</option><option value={86}>TERRITORI PALESTINESI (GAZA)</option><option value={87}>GEORGIANA</option><option value={88}>TEDESCA (GERMANIA)</option><option value={89}>TEDESCA (GERMANIA REPUBBLICA DEMOCRATICA)</option><option value={90}>TEDESCA (GERMANIA REPUBBLICA FEDERALE)</option><option value={91}>GANESE</option><option value={92}>GIAMAICANA</option><option value={93}>GIAPPONESE</option><option value={94}>INGLESE (GIBILTERRA)</option><option value={95}>GIBUTI</option><option value={96}>GIORDANA</option><option value={97}>INGLESE (GRAN BRETAGNA E IRLANDA DEL NORD)</option><option value={98}>GRECA</option><option value={99}>GRENADA</option><option value={100}>GROENLADESE</option><option value={101}>GUADALUPA</option>
                                            <option value={102}>GUAM (ISOLA)</option><option value={103}>GUATEMALTECA</option><option value={104}>GUIANA FRANCESE</option><option value={105}>GUINENSE (GUINEA)</option><option value={106}>GUINENSE (GUINEA BISSAU)</option><option value={107}>GUINENSE (GUINEA EQUATORIALE)</option><option value={108}>GUYANA</option><option value={109}>HAITIANA</option><option value={110}>ONDUREGNA</option><option value={111}>CINESE (HONG KONG)</option><option value={112}>INDIANA</option><option value={113}>INDONESIANA</option>
                                            <option value={114}>IRANIANA</option><option value={115}>IRACHENA</option><option value={116}>IRIANA</option><option value={117}>IRLANDESE</option><option value={118}>ISLANDESE</option><option value={119}>ISOLE CILENE (PASQUA E SALA Y GOMEZ)</option>
                                            <option value={120}>ISOLE VERGINI BRITANNICHE</option><option value={121}>ISRALIANO</option><option value={123}>IUGOSLAVA</option><option value={124}>KAZAKA</option><option value={125}>KENIOTA</option><option value={126}>KIRGIKA</option><option value={127}>KIRIBATI</option><option value={128}>KUWAITIANA</option><option value={129}>FRANCESE (ISOLA LA REUNION)</option><option value={130}>LOASSIANA</option><option value={131}>LESOTHO</option><option value={132}>LETTONE</option><option value={133}>LIBANESE (LIBANO)</option><option value={134}>LIBERIANA</option><option value={135}>LIBANESE (LIBIA)</option><option value={136}>LIECHTENSTEIN</option><option value={137}>LITUANA</option><option value={138}>LUSSEMBURGHESE</option><option value={139}>MACAONSE</option><option value={140}>MACEDONE</option><option value={141}>MACQUARIE (ISOLE)</option><option value={142}>MADAGASCAR</option><option value={143}>MALAWENSE</option><option value={144}>MALAISIANA</option><option value={145}>MALDIVIANA</option><option value={146}>MALIANA</option><option value={147}>MALTESE</option><option value={148}>MALVINE O FALKLAND (ISOLE)</option>
                                            <option value={149}>INGLESE (ISOLA MAN)</option><option value={150}>MARIANNE (ISOLE)</option><option value={151}>MAROCCHINA</option><option value={152}>AMERICANA (MARSHALL)</option><option value={153}>MARTINICA</option><option value={154}>MAURITANENSE</option><option value={155}>MAURITANA</option><option value={156}>FRANCESE (ISOLA MAYOTTE)</option><option value={157}>MESSICANA</option><option value={158}>MICRONESIANA</option><option value={159}>MIDWAY</option><option value={160}>MOLDAVA</option><option value={161}>MONAGHESCA</option><option value={162}>MONGOLA</option><option value={163}>INGLESE (MONTSERRAT)</option><option value={164}>MOZAMBICANA</option><option value={165}>NAMIBIANA</option><option value={166}>NAURU</option><option value={167}>NEPALESE</option><option value={168}>NICARAGUENSE</option><option value={169}>NIGER</option><option value={170}>NIGERIANA</option><option value={171}>NIUE O SAVAGE (ISOLE)</option><option value={172}>NORFOLK (ISOLE DEL MAR DEI CORALLI)</option><option value={173}>INGLESE (ISOLE NORMANNE)</option><option value={174}>NORVEGESE (NORVEGIA)</option><option value={175}>CALEDONE</option>
                                            <option value={176}>NEOZELANDESE (NUOVA ZELANDA)</option><option value={177}>OMAN</option><option value={178}>OLANDESE</option><option value={179}>PAKISTANA</option><option value={180}>PALAU</option><option value={181}>PANAMENSE (PANAMA)</option><option value={182}>PANAMENSE (PANAMA ZONA DEL CANALE)</option><option value={183}>PAPUA NUOVA GUINEA</option><option value={184}>PARAGUAIANA</option><option value={185}>PERUVIANA</option><option value={186}>PITCAIRN (E DIPENDENZE)</option><option value={187}>POLINESIANA</option><option value={188}>POLACCA</option><option value={189}>PORTOGHESE</option><option value={190}>PORTIRICANA</option><option value={191}>QATAR</option><option value={192}>CECA</option><option value={193}>REPUBBLICA DELLA GUAYANA</option><option value={194}>DOMINICANA</option><option value={195}>RUMENA</option><option value={196}>RUANDESE</option><option value={197}>RUSSA</option><option value={198}>SAINT KITTS E NEVIS</option><option value={199}>SANTA LUCIA</option><option value={200}>SAINT PIERRE ET MIQUELON</option><option value={201}>SAINT VINCENT E GRENADINE</option><option value={202}>SALOMONE</option><option value={203}>SAMOANA (SAMOA)</option><option value={204}>SAMOANA (ISOLE SAMOA AMERICANE)</option><option value={205}>SAN MARINESE</option><option value={206}>SANT'ELENA (ISOLA)</option><option value={207}>SAO TOME' E PRINCIPE</option><option value={208}>SEICELLE</option><option value={209}>SENEGALESE</option><option value={210}>SIERRA LEONE</option><option value={211}>SINGAPORE</option><option value={212}>SIRIANA</option><option value={213}>SLOVACCA</option><option value={214}>SLOVENA</option><option value={215}>SOMALA</option>
                                            <option value={216}>SPAGNOLA</option><option value={217}>CINGALESE</option><option value={218}>AMERICANA (STATI UNITI D'AMERICA)</option><option value={219}>STRANIERA</option><option value={220}>SUDAFRICANA (SUDAFRICANA REBUBBLICA)</option><option value={221}>SUDANESE</option><option value={222}>SURINAMENSE</option><option value={223}>SVEDESE</option><option value={224}>SVIZZERA</option><option value={225}>SWAZILAND</option><option value={226}>TAGIKA</option><option value={227}>TAIWANESE</option><option value={228}>TANZANESE</option><option value={229}>TAILANDESE</option><option value={230}>TIMORESE</option><option value={231}>TOGO</option><option value={232}>TOKELAU (ISOLE DELL'UNIONE)</option><option value={233}>TONGA (ISOLE DEGLI AMICI)</option><option value={234}>TRINIDAD E TOBAGO</option><option value={235}>TUNISINA</option><option value={236}>TURCA</option><option value={237}>TURKMENA</option><option value={238}>TURKS E CAICOS (ISOLE)</option><option value={239}>TUVALU</option><option value={240}>UCRAINA</option><option value={241}>UGANDESE</option><option value={242}>UNGHERESE</option><option value={243}>URUGUAIANA</option><option value={244}>UZBEKA</option><option value={245}>VANUATU</option><option value={246}>VENEZUELANA</option><option value={247}>ISOLE VERGINI AMERICANE</option><option value={248}>VIETNAMITA</option><option value={249}>VOLTA (ALTOVOLTA)</option><option value={250}>WALLIS E FUTUNA (ISOLE)</option><option value={251}>YEMENITA</option><option value={252}>ZAMBESE</option><option value={253}>ZIMBABWESE</option><option value={254}>KOSOVARA</option><option value={255}>SERBA</option><option value={256}>URSS - Unione Repubbliche Socialiste Sovietiche</option><option value={257}>SIERRALEONESE</option><option value={258}>APOLIDE</option><option value={259}>MONTENEGRINA</option><option value={260}>TOGOLESE</option><option value={261}>PALESTINESE</option><option value={263}>SERBA</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <br />

                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Dati Residenza / Domicilio</div></div>
                            <div className="row">
                                <div className="col-sm">
                                    <Field component={InputField} id='indirizzoresidenza' label='Residente nel Comune di alla Via' />
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='civicoresidenza' label='Civico di residenza' />
                                </div>
                            </div>

                            <div className="row">

                                <div className="col-sm">
                                    <Field component={InputField} id='indirizzodomicilio' label='Domicilio (se diverso dalla residenza)' />
                                </div>
                            </div>

                            <br />
                           
                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Recapiti</div></div>

                            <div className="row">
                                <div className="col-sm">
                                    <div className="form-group">
                                        <label htmlFor='email'>e-mail</label>
                                        <input type="text" className="form-control" name='email' id='email' onChange={event => formik.setFieldValue('email', event.target.value)} />
                                        <small className="error">  <ErrorMessage name='email' /> </small>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div className="form-group">
                                        <label htmlFor='confermaemail'>conferma e-mail</label>
                                        <input type="text" className="form-control" name='confermaemail' id='confermaemail' onChange={event => formik.setFieldValue('confermaemail', event.target.value)} />
                                        <small className="error">  <ErrorMessage name='confermaemail' /> </small>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='telefono' label='telefono' />
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='cellulare' label='Cellulare' />
                                </div>
                            </div>


                            <br />
                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Presenta

                            </div></div>


                            <p>
                                la domanda per l’assegnazione del contributo economico per la frequenza di attività, organizzate dai
                                centri estivi, dai servizi socioeducativi territoriali e dai centri con funzione educativa e ricreativa,
                                nel periodo 01 giugno 2024 – 31 dicembre 2024, per il/i sottoelencato/i minore/i appartenente/i al
                                proprio nucleo familiare:

                                <select id="numfigli" style={{ marginLeft: 10, marginRight: 10 }} onChange={(e) => { aggiungiFigli(e.target.value, formik); }}>
                                    <option value="0"> Seleziona Numero Minori</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                </select>

                            </p>

                            <br />

                            <FieldArray
                                name="figli"
                                render={arrayHelpers => {
                                    const figli = formik.values.figli;
                                    function handleFormChange(index: React.Key, event: React.ChangeEvent<HTMLInputElement>): void {

                                        formik.values.figli[index + ''][event.target.name.split('.')[2]] = event.target.value;
                                      // console.log('value ', event.target.value, event.target.name.split('.')[2])

                                    }

                                    return (

                                        <div>
                                            {figli && figli.length > 0
                                                ? figli.map((figlio: any, index: React.Key) => (
                                                    <div key={index}>

                                                        <div style={{ border: 'solid', padding: 30 }} key={index}>
                                                            <div className="row"><label>Minore {parseInt('' + index) + 1}</label>

                                                                <div className="col-sm">
                                                                    <div className="form-group">

                                                                        <label htmlFor={`figli.${index}.nome`}>Nome</label>
                                                                        <input type="text" className="form-control" name={`figli.${index}.nome`} id={`figli.${index}.nome`} onChange={event => handleFormChange(index, event)} />
                                                                        <small className="error">    <ErrorMessage name={`figli.${index}.nome`} /> </small>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`figli.${index}.cognome`}>Cognome</label>
                                                                        <input type="text" className="form-control" name={`figli.${index}.cognome`} id={`figli.${index}.cognome`} onChange={event => handleFormChange(index, event)} />
                                                                        <small className="error">    <ErrorMessage name={`figli.${index}.cognome`} /> </small>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`figli.${index}.natoa`}>Nato a</label>
                                                                        <input type="text" className="form-control" name={`figli.${index}.natoa`} id={`figli.${index}.natoa`} onChange={event => handleFormChange(index, event)} />
                                                                        <small className="error">  <ErrorMessage name={`figli.${index}.natoa`} /> </small>

                                                                    </div>
                                                                </div>

                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label className="active" htmlFor={`figli.${index}.natoil`}>Data di nascita (gg/mm/aaaa)</label>
                                                                        <input type="date" id={`figli.${index}.natoil`} name={`figli.${index}.natoil`} onChange={event => handleFormChange(index, event)} />
                                                                        <small className="error">  <ErrorMessage name={`figli.${index}.natoil`} /> </small>

                                                                    </div>
                                                                </div>

                                                            </div>



                                                            <div className="row">

                                                                <FieldArray
                                                                    name="centri"
                                                                    render={arrayHelpers => {
                                                                     
                                                                        function handleFormChange(index: React.Key, event: React.ChangeEvent<HTMLInputElement>): void {
                                                                            
                                                                            let inpid= event.target.name.split('.');
                                                                            formik.values.figli[inpid[1]].centri[inpid[3]][inpid[4]]= event.target.value;;
                                                                          

                                                                        }

                                                                        return (
                                                                            <div style={{ width: '100%' }}>
                                                                               
                                                                                {formik.values.figli[parseInt('' + index)].centri.length > 0
                                                                                    ? formik.values.figli[parseInt('' + index)].centri.map((autoval: any, indice: React.Key) => (
                                                                                        <div key={indice}>

                                                                                            <div className="row">

                                                                                                <div className="col-sm">
                                                                                                    <div className="form-group">
                                                                                                        <label htmlFor={`figli.${index}.centri.${indice}.centro`}>Nome Centro Frequentato</label>
                                                                                                   
                                                                                                        <input type="text" className="form-control" name={`figli.${index}.centri.${indice}.centro`} id={`figli.${index}.centri.${indice}.centro`} onChange={event => handleFormChange(index, event)}  />
                                                                                                        <small className="error">  <ErrorMessage name={`figli.${index}.centri.${indice}.centro`} /> </small>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="col-sm">
                                                                                                    <div className="form-group">
                                                                                                        <label className="active" htmlFor={`figli.${index}.centri.${indice}.frequenzada`}>Periodo Frequenza da (gg/mm/aaaa)</label>
                                                                                                        <input type="date" id={`figli.${index}.centri.${indice}.frequenzada`} name={`figli.${index}.centri.${indice}.frequenzada`} onChange={event => handleFormChange(index, event)} />
                                                                                                        <small className="error">  <ErrorMessage name={`figli.${index}.centri.${indice}.frequenzada`} /> </small>

                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="col-sm">
                                                                                                    <div className="form-group">
                                                                                                        <label className="active" htmlFor={`figli.${index}.centri.${indice}.frequenzaa`}>Periodo Frequenza a (gg/mm/aaaa)</label>
                                                                                                        <input type="date" id={`figli.${index}.centri.${indice}.frequenzaa`} name={`figli.${index}.centri.${indice}.frequenzaa`} onChange={event => handleFormChange(index, event)} />
                                                                                                        <small className="error">  <ErrorMessage name={`figli.${index}.centri.${indice}.frequenzaa`} /> </small>

                                                                                                    </div>
                                                                                                </div>

                                                                                            </div>

                                                                                        </div>

                                                                                    ))
                                                                                    : null}
                                                                                       <small className="error"><ErrorMessage name={`figli.${index}.centri`} /></small>
                                                                            
                                                                            </div>
                                                                        );
                                                                    }}
                                                                />

                                                                <div className="row"></div>
                                                                <div style={{ marginTop: 20, width: '100%' }} className="row">
                                                                    <br />
                                                                    {
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => aggiungicentro(index, formik)} // insert an empty string at a position
                                                                                    >Aggiungi centro
                                                                                    </button>


                                                                                }
                                                                             

                                                                </div>

                                                            </div>



                                                            {
                                                                false && <div className="row">

                                                                    <div className="col-sm">
                                                                        <div className="form-group">
                                                                            Aggiungere possibilità di aggiungere più centri
                                                                            <label htmlFor={`figli.${index}.centro`}>Centro .....</label>
                                                                            <input type="text" className="form-control" name={`figli.${index}.centro`} id={`figli.${index}.centro`} onChange={event => handleFormChange(index, event)} />
                                                                            <small className="error">  <ErrorMessage name={`figli.${index}.centro`} /> </small>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm">
                                                                        <div className="form-group">
                                                                            <label className="active" htmlFor={`figli.${index}.frequenzada`}>Periodo Frequenza da (gg/mm/aaaa)</label>
                                                                            <input type="date" id={`figli.${index}.frequenzada`} name={`figli.${index}.frequenzada`} onChange={event => handleFormChange(index, event)} />
                                                                            <small className="error">  <ErrorMessage name={`figli.${index}.frequenzada`} /> </small>

                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm">
                                                                        <div className="form-group">
                                                                            <label className="active" htmlFor={`figli.${index}.frequenzaa`}>Periodo Frequenza a (gg/mm/aaaa)</label>
                                                                            <input type="date" id={`figli.${index}.frequenzaa`} name={`figli.${index}.frequenzaa`} onChange={event => handleFormChange(index, event)} />
                                                                            <small className="error">  <ErrorMessage name={`figli.${index}.frequenzaa`} /> </small>

                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            }

                                                        </div>


                                                    </div>
                                                ))
                                                : null}
                                           
                                        </div>
                                    );
                                }}
                            />

                            {visual && <>



                                <br />
                                <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>A TAL FINE CONSAPEVOLE CHE</div></div>

                                <div className="form-check">

                                    <input id="dichiara01" type="checkbox" onChange={event => formik.setFieldValue('dichiara01', event.target.checked)} />

                                    <label htmlFor="dichiara01" >
                                        a norma degli articoli 75 e 76 del D.P.R. 28.12.2000, n. 445 e successive modificazioni ed
                                        integrazioni, chi rilascia dichiarazioni mendaci è punito ai sensi del codice penale e delle leggi
                                        speciali in materia e decade dai benefici eventualmente conseguenti al provvedimento emanato
                                        sulla base della dichiarazione non veritiera;

                                    </label>

                                    {formik.errors.dichiara01 && <small className="error">*Obbligatorio</small>}
                                </div>

                                <div className="form-check">

                                    <input id="dichiara02" type="checkbox" onChange={event => formik.setFieldValue('dichiara02', event.target.checked)} />

                                    <label htmlFor="dichiara02" >
                                        ai sensi dell’articolo 71 del DPR 445/2000, l’Ente Pubblico ha l’obbligo di effettuare idonei
                                        controlli, anche a campione, sulla veridicità di quanto dichiarato ai sensi degli articoli 46 e 47 del
                                        DPR 445/2000
                                    </label>

                                    {formik.errors.dichiara02 && <small className="error">*Obbligatorio</small>}
                                </div> <br />
                                <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>SI IMPEGNA</div></div>

                                <div className="form-check">

                                    <input id="dichiarafatture" type="checkbox" onChange={event => formik.setFieldValue('dichiarafatture', event.target.checked)} />

                                    <label htmlFor="dichiarafatture" > a trasmettere fattura o ricevuta quietanzata della retta di frequenza rilasciata alla famiglia dal soggetto
                                        gestore del servizio e contenente, obbligatoriamente, i seguenti elementi:<br />
                                        a. l’intestazione dell’ente gestore completa del codice fiscale;<br />
                                        b. la numerazione progressiva obbligatoria;<br />
                                        c. la data di emissione della ricevuta;<br />
                                        d. il nome e cognome del genitore da cui si percepisce il corrispettivo, che deve
                                        corrispondere a quello che ha richiesto il contributo;<br />
                                        e. il nome e cognome del minore per il quale è stato richiesto il contributo;<br />
                                        f. somma pagata in cifre e in lettere;<br />
                                        g. motivazione o causale.<br />
                                        h. attestazione di frequenza rilasciata dal soggetto erogante il servizio estivo con indicazione
                                        del periodo (dal/al)</label>

                                    {formik.errors.dichiarafatture && <small className="error">*Obbligatorio</small>}
                                </div>
                                <br />


                                <br />
                                <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>DICHIARA</div></div>

                                <p>ai sensi degli articoli 46 e 47 del DPR 445/2000:</p>

                                <div>

                                    <div className="form-check">
                                        <input id="dichiara5" type="checkbox" onChange={event => formik.setFieldValue('dichiara5', event.target.checked)} />
                                        <label htmlFor="dichiara5" >
                                            di aver preso visione delle condizioni del bando, del valore del contributo, delle modalità di
                                            concessione e utilizzo dello stesso, dei motivi di esclusione e di accettarli integralmente di
                                            impegnarsi a comunicare tempestivamente al Comune di Rende l’eventuale rinuncia al contributo
                                            e/ o variazioni che incidano per il riconoscimento del contributo.

                                        </label>
                                        {formik.errors.dichiara5 && <small className="error">*Obbligatorio</small>}
                                    </div>
                                    <br />
                                    <strong>di essere in possesso di tutti i requisiti previsto dall'Avviso:</strong>
                                    <div className="form-check">

                                        <input id="dichiara1" type="checkbox" onChange={event => formik.setFieldValue('dichiara1', event.target.checked)} />

                                        <label htmlFor="dichiara1" >
                                            di avere la residenza anagrafica nel Comune di Rende unitamente al/ai minore/i, sopra indicato/i
                                            per il/i quale/i si chiede il contributo;
                                        </label>

                                        {formik.errors.dichiara1 && <small className="error">*Obbligatorio</small>}
                                    </div>

                                    <div className="form-check">

                                        <input id="dichiara00" type="checkbox" onChange={event => formik.setFieldValue('dichiara00', event.target.checked)} />

                                        <label htmlFor="dichiara00" >
                                            di essere in possesso di documentazione valida, attestante, nel periodo ricompreso tra 1 giugno
                                            2024 e 31 dicembre 2024, la frequenza del/i minore/i ad una delle suddette attività, la
                                            relativa spesa sostenuta e contenente tutti i dati necessari ad identificare la tipologia di
                                            soggetto erogatore.
                                        </label>

                                        {formik.errors.dichiara00 && <small className="error">*Obbligatorio</small>}
                                    </div>
                                    <div className="form-check">
                                        <input id="dichiara4" type="checkbox" onChange={event => formik.setFieldValue('dichiara4', event.target.checked)} />
                                        <label htmlFor="dichiara4" >
                                            Di non beneficiare, per lo stesso periodo di riferimento e per il medesimo minore per
                                            cui si chiede il rimborso, di contributi per la stessa finalità erogati dall’INPS o da altro
                                            Ente (a titolo esemplificativo e non esaustivo: buoni servizio regionali, contributi centri
                                            estivi INPS ecc.)

                                        </label>
                                        {formik.errors.dichiara4 && <small className="error">*Obbligatorio</small>}
                                    </div>
                                    <div className="form-check">
                                        <input id="dichiara2" type="checkbox" onChange={event => formik.setFieldValue('dichiara2', event.target.checked)} />
                                        <label htmlFor="dichiara2" >
                                            che l’Indicatore della Situazione Economica Equivalente (ISEE 2024) del nucleo familiare, in corso di
                                            validità, oppure isee corrente non è superiore a euro 40.000,00; (Nel caso di nuclei familiari con figli minori, i cui genitori non siano coniugati e non
                                            convivano, occorre essere in possesso di ISEE minorenni in corso di validità, nel
                                            rispetto delle vigenti Normative in materia di ISEE).
                                        </label>
                                        {formik.errors.dichiara2 && <small className="error">*Obbligatorio</small>}
                                    </div>



                                    <div className="form-check" >


                                        <input id="dichiaraisee2" type="checkbox" name="dichiaraisee" onChange={event => formik.setFieldValue('dichiaraisee', event.target.checked)} />
                                        <label htmlFor="dichiaraisee2" > Di avere e di allegare alla presente una attestazione ISEE in corso di validità del nucleo familiare nel quale è inserito il minore

                                        </label>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div style={{ maxWidth: 200 }} className="form-group">
                                                    <label htmlFor='valoreisee'> Valore ISEE €</label>
                                                    <input type="text" className="form-control" name='valoreisee' id='valoreisee' onChange={event => formik.setFieldValue('valoreisee', event.target.value)} />
                                                    <small className="error">  <ErrorMessage name='valoreisee' /> </small>
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <label className="active" > Con validità al </label>
                                            </div>
                                            <div className="col-sm">

                                                <div className="form-group">

                                                    <input type="date" id="iseevalido" name="iseevalido" onChange={evt => {
                                                        formik.setFieldValue('iseevalido', evt.target.value)
                                                    }} />

                                                    <small className="error">  <ErrorMessage name='iseevalido' /> </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="form-check">
                                        <p>che il nucleo familiare si trova in una delle seguenti condizioni di priorità</p>
                                        <input id="dichiaranucleo" type="checkbox" name="dichiaranucleo" onChange={event => formik.setFieldValue('dichiaranucleo', event.target.checked)} />
                                        <label htmlFor="dichiaranucleo" > Minori con Disabilità</label>

                                    </div>

                                </div>

                                <br />

                                <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>DICHIARA ALTRESI'</div></div>



                                <div className="form-check">
                                    <input id="dichiara20" type="checkbox" onChange={event => formik.setFieldValue('dichiara20', event.target.checked)} />
                                    <label htmlFor="dichiara20" >
                                        di accettare che tutte le comunicazioni tra le parti avvengano a mezzo email e di indicare il
                                        seguente indirizzo email per le comunicazioni relative alla presente procedura;
                                    </label>
                                    {formik.errors.dichiara20 && <small className="error">*Obbligatorio</small>}
                                </div>


                                <div className="form-check">
                                    <input id="dichiara21" type="checkbox" onChange={event => formik.setFieldValue('dichiara21', event.target.checked)} />
                                    <label htmlFor="dichiara21" >
                                        di essere a conoscenza del fatto che il Comune di Rende potrà effettuare controlli per la
                                        verifica delle autocertificazioni presentate e, nei casi di dichiarazioni false rilasciate al fine di
                                        ottenere indebitamente il beneficio di che trattasi, il richiedente decadrà immediatamente dal
                                        beneficio concessogli e potrà incorrere nelle sanzioni del codice penale e dalle leggi specifiche
                                        in materia;
                                    </label>
                                    {formik.errors.dichiara21 && <small className="error">*Obbligatorio</small>}
                                </div>


                                <div className="form-check">
                                    <input id="dichiara22" type="checkbox" onChange={event => formik.setFieldValue('dichiara22', event.target.checked)} />
                                    <label htmlFor="dichiara22" >
                                        di essere informato, ai sensi del Regolamento (UE) 2016/679 del Parlamento europeo e del
                                        Consiglio del 27 aprile 2016, che i dati raccolti saranno trattati, anche con strumenti
                                        informatici, nell’ambito del procedimento per il quale la presente dichiarazione viene resa;
                                    </label>
                                    {formik.errors.dichiara22 && <small className="error">*Obbligatorio</small>}
                                </div>

                                <br />

                                <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Per quanto sopra dichiarato, CHIEDE</div></div>


                                <p>(barrare la presente casella solo nel caso in cui la famiglia richiedente abbia anticipato con risorse proprie il
                                    costo della retta di frequenza),

                                </p>

                                <div className="form-check">
                                    <input id="dichiaraiban" type="checkbox" onChange={event => formik.setFieldValue('dichiaraiban', event.target.checked)} />
                                    <label htmlFor="dichiaraiban" >
                                        l’erogazione del contributo economico nella misura e con le modalità indicate nell’Avviso pubblico,
                                        mediante accredito sul c.c bancario o postale intestato a:

                                    </label>
                                    {formik.errors.dichiaraiban && <small className="error">*Obbligatorio</small>}
                                </div>


                                <div className="row">

                                    <div className="col-sm">
                                        <div className="form-group">
                                            <label htmlFor='iban'>Iban</label>
                                            <input type="text" className="form-control" name='iban' id='iban' onChange={event => formik.setFieldValue('iban', event.target.value)} />
                                            <small className="error">  <ErrorMessage name='iban' /> </small>

                                        </div>
                                    </div>

                                    <div className="col-sm">
                                        <div className="form-group">
                                            <label htmlFor='intestato'>Nominativo</label>
                                            <input type="text" className="form-control" name='intestato' id='intestato' onChange={event => formik.setFieldValue('intestato', event.target.value)} />
                                            <small className="error">  <ErrorMessage name='intestato' /> </small>

                                        </div>
                                    </div>
                                </div>

                                <br />

                                <br />
                                <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Allega</div></div>

                                <div className="form-upload" style={{ padding: 20 }}>
                                    <label style={{ textOverflow: 'unset', whiteSpace: 'unset', lineHeight: 'inherit' }} htmlFor="documento" className="active">
                                        Copia del documento di riconoscimento, in corso di validità, del richiedente;
                                    </label>
                                    <input type="file" name="documento" id="documento" required className="is-invalid" data-focus-mouse="false" aria-invalid="true" aria-describedby="upload-error-1"
                                        onChange={e => formik.setFieldValue(`allegati.${0}.documento`, e.target.files[0])}
                                    />
                                    <small className="error"><ErrorMessage name={`allegati.${0}.documento`} /></small>

                                </div>

                                <div className="form-upload" style={{ padding: 20 }}>
                                    <label style={{ textOverflow: 'unset', whiteSpace: 'unset', lineHeight: 'inherit' }} htmlFor="documentominore" className="active">
                                        Copia del documento di riconoscimento, in corso di validità, del minore beneficiario;
                                    </label>
                                    <input type="file" name="documentominore" id="documentominore" required className="is-invalid" data-focus-mouse="false" aria-invalid="true" aria-describedby="upload-error-1"
                                        onChange={e => formik.setFieldValue(`allegati.${0}.documentominore`, e.target.files[0])}
                                    />
                                    <small className="error"><ErrorMessage name={`allegati.${0}.documentominore`} /></small>

                                </div>


                                <div className="form-upload" style={{ padding: 20 }}>
                                    <p className="active">Copia della attestazione ISEE 2024 ordinario in corso di validità alla data di presentazione
                                        della domanda OPPURE ISEE CORRENTE, o, nel caso di nuclei familiari con figli minori, i
                                        cui genitori siano separati legalmente, non siano coniugati e non convivano, occorre essere in
                                        possesso di ISEE minorenni in corso di validità, nel rispetto delle vigenti normative in materia
                                        di ISEE; </p>
                                    <input type="file" name="fileisee" id="fileisee" className="is-invalid" data-focus-mouse="false" aria-invalid="true" aria-describedby="upload-error-6" style={{}}

                                        onChange={e => (formik.setFieldValue(`allegati.${0}.fileisee`, e.target.files[0]))}
                                    />
                                    <small className="error"><ErrorMessage name={`allegati.${0}.fileisee`} /></small>

                                </div>


                                <div className="form-upload" style={{ padding: 20 }}>
                                    <label htmlFor="dichiarazionenucleo" className="active">Dichiarazione attestante la composizione del proprio nucleo familiare; </label>
                                    <input type="file" name="dichiarazionenucleo" id="dichiarazionenucleo" className="is-invalid" data-focus-mouse="false" aria-invalid="true" aria-describedby="upload-error-6" style={{}}

                                        onChange={e => (formik.setFieldValue(`allegati.${0}.dichiarazionenucleo`, e.target.files[0]))}
                                    />
                                    <small className="error"><ErrorMessage name={`allegati.${0}.dichiarazionenucleo`} /></small>

                                </div>
                                <div className="form-upload" style={{ padding: 20 }}>
                                    <p className="active"> Copia del verbale attestante riconoscimento disabilità del minore grave certificata,
                                        L.n.104/92 c.3 (o autocertificazione resa ai sensi dell’art art. 46 D.P.R.28 dicembre 2000 n.
                                        445);  </p>
                                    <input type="file" name="minoridisabili" id="minoridisabili" className="is-invalid" data-focus-mouse="false" aria-invalid="true" aria-describedby="upload-error-6" style={{}}

                                        onChange={e => (formik.setFieldValue(`allegati.${0}.minoridisabili`, e.target.files[0]))}
                                    />
                                    <small className="error"><ErrorMessage name={`allegati.${0}.minoridisabili`} /></small>

                                </div>

                                <div className="form-upload" style={{ padding: 20 }}>
                                    <label htmlFor="sostitutiva" className="active">Dichiarazione sostitutiva di certificazione <a target={'_blank'} href="/Allegato1-1.doc"> (file esempio)</a></label>
                                    <input type="file" name="sostitutiva" id="sostitutiva" className="is-invalid" data-focus-mouse="false" aria-invalid="true" aria-describedby="upload-error-6" style={{}}

                                        onChange={e => (formik.setFieldValue(`allegati.${0}.sostitutiva`, e.target.files[0]))}
                                    />
                                    <small className="error"><ErrorMessage name={`allegati.${0}.sostitutiva`} /></small>

                                </div>

                                <div className="form-upload" style={{ padding: 20 }}>
                                    <label htmlFor="altro" className="active">Copia di documentazione valida, rilasciata dalla struttura in cui si sono svolte le attività (come indicato nella sezione sopra denominata <strong>SI IMPEGNA</strong> ) </label>
                                    <input type="file" name="altro" id="altro" className="is-invalid" data-focus-mouse="false" aria-invalid="true" aria-describedby="upload-error-6" style={{}}

                                        onChange={e => (formik.setFieldValue(`allegati.${0}.altro`, e.target.files[0]))}
                                    />
                                    <small className="error"><ErrorMessage name={`allegati.${0}.altro`} /></small>

                                </div>


                                <div style={{ display: 'none' }} id='spinner' className="progress progress-indeterminate">
                                    <span className="visually-hidden">In elaborazione...</span>
                                    <div className="progress-bar" role="progressbar" />
                                </div>
                                <hr />
                                <div className="form-group">
                                    <div className="btn-group col-sm-5 col-sm-offset-6 ">
                                        <button name="_anteprima" id="_anteprima" value="true" type="button" className="btn btn-primary btn-md pull-left" style={{ width: 150, display: 'none' }}

                                            onClick={() => {
                                                stampa_id('root');
                                                console.log(formik.errors);
                                            }}

                                        >Anteprima</button>
                                        {/**   <button name="_stampadomanda" id="_stampadomanda" value="true" type="button" className="btn btn-primary btn-md pull-left" style={{ width: 150 }}>Stampa domanda</button>
                                   */}  <button name="_conferma" id="_conferma" value="true" type="button" className="btn btn-primary btn-md pull-left" style={{ width: 150 }} onClick={() => {

                                            // alert('invio');

                                            formik.validateForm().then(async res => {
                                                const { ob } = await res;

                                                let b = Object.keys(res).length;


                                                //       console.log('res', b, res);

                                                //     console.log(b);

                                              /*  if (res.figli !== undefined) {

                                                    b = b - 1;
                                                    // @ts-ignore 
                                                    for (let i = 0; i < res.figli.length; i++) {
                                                        // @ts-ignore 
                                                        b += Object.keys(res.figli[i]).length;
                                                    }

                                                    console.log(b);
                                                } //*/

                                                if (res.allegati !== undefined) {
                                                    b = b - 1;
                                                    // @ts-ignore 
                                                    b += Object.keys(res.allegati[0]).length;

                                                }

                                                console.log(b);


                                                if (b > 0) {
                                                    Toast.fire({
                                                        title: 'ci sono ' + b + ' Errori nella compilazione',
                                                        icon: 'error'
                                                    });
                                                } else {
                                                    document.getElementById('spinner').style.display = 'inline';
                                                    document.getElementById('_conferma').style.display = 'none';

                                                }


                                            });

                                            console.log(formik.errors);

                                            formik.submitForm();

                                        }}>Invia</button></div>
                                </div>
                            </>
                            }
                        </div>}
                    </div>)}
            </Formik>


        </>
    )
}

export default Domanda;